// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"index_dialogContent_3sDp4","dialogImg":"index_dialogImg_1yQJa"};